module.exports = __webpack_public_path__ + "static/img/3s-platform-img8.de5d0d1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/web/3s-platform-img8.png
// module id = elJj
// module chunks = 0